import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=546f5f9a&scoped=true"
var script = {}
import style0 from "./BoasVindas.vue?vue&type=style&index=0&id=546f5f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f5f9a",
  null
  
)

export default component.exports